import { RequestConfig } from '@/interface'
const PRIFIX = 'fpgl/template/'
const fastInvoiceConfig: RequestConfig = {
  // 模板详情
  fastInfo: {
    url: `${PRIFIX}info`,
    method: 'post'
  },
  // 模板状态变更
  fastModifyZt: {
    url: `${PRIFIX}modifyZt`,
    method: 'post'
  },
  // 订单二维码
  orderQrCode: {
    url: `${PRIFIX}orderQrCode`,
    method: 'post'
  },
  // 模板扫描开票列表
  qrCodeList: {
    url: `${PRIFIX}qrCodeList`,
    method: 'post'
  },
  // 快捷开票
  fastQueryPageList: {
    url: `${PRIFIX}queryPageList`,
    method: 'post'
  },
  // 保存模板
  fastSaveOrUpdate: {
    url: `${PRIFIX}saveOrUpdate`,
    method: 'post'
  },
  // 删除模板
  delFastTemplate: {
    url: `${PRIFIX}dels`,
    method: 'post'
  }
}
export default fastInvoiceConfig
